import { render, staticRenderFns } from "./Audit-Admin.vue?vue&type=template&id=f03a08fa&scoped=true"
import script from "./Audit-Admin.js?vue&type=script&lang=js&external"
export * from "./Audit-Admin.js?vue&type=script&lang=js&external"
import style0 from "./Audit-Admin.vue?vue&type=style&index=0&id=f03a08fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03a08fa",
  null
  
)

export default component.exports